import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DISPLAY_LANG } from "../../../config";
import { getUserDomains, getUserDomainPageData } from "../../../api/user/active-services/domain";
import Loading from "../../../components/loading";
import "./userDomains.css";

export default function UserDomainPage() {
  const [domainList, setDomainList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    const loadingData = async () => {
      const resDomainList = await getUserDomains();
      setDomainList(resDomainList);

      const resPageData = await getUserDomainPageData();
      setPageData(resPageData);

      setLoading(false);
    };

    loadingData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="UserDomainPage wrapper">
      <h1>{pageData.title[DISPLAY_LANG]}</h1>

      {!!domainList.length && (
        <div className="user-domain-list">
          {domainList.map((elem, index) => (
            <div className="user-domain-item" key={index}>
              <p>{elem.domain}</p>

              <Link to={`/user/domains/${elem.order_id}`}>
                <img src="/images/partials/edit.svg" alt="edit" />
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
